// extracted by mini-css-extract-plugin
export default {"wizard_options":"WizardOptions_wizard_options__ueK8u","spin":"WizardOptions_spin__cHi9O"};